var codeblock_default = {
  "blockStyleSpacing": "Xd5Wk",
  "codeBlock": "szUBD Xd5Wk",
  "renderedInTable": "Nsj4s"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
